module.exports = __webpack_public_path__ + "img/planejamento.ff3aa836.svg";